function getCookies() {
	const pairs = document.cookie.split(';');
	const cookies = {};
	for (let i = 0; i < pairs.length; i++) {
		const pair = pairs[i].split('=');
		cookies[pair[0].trim()] = decodeURIComponent(pair.slice(1).join('='));
	}
	return cookies;
}

function initGatedResourceDownloads() {
	const content = document.querySelector('.gated-content');
	if (content) {
		const xhr = new XMLHttpRequest();

		xhr.open('POST', window.gatedContent.ajax, true);

		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4 && xhr.status === 200) {
				const response = xhr.responseText;
				if (response) {
					content.innerHTML = response;
				}
				content.classList.remove('hide');
			}
		};

		xhr.onerror = function () {
			console.warn(xhr.responseText);
		};

		const cookiesArray = Object.entries(getCookies()).map(([key, value]) => `${key}=${value}`);
		const cookiesParam = cookiesArray.join('&');
		const postData = `action=get_the_content&cookies=${encodeURIComponent(cookiesParam)}&postID=${window.gatedContent.postID}&postType=${window.gatedContent.postType}`;
		xhr.send(postData);
	}
}

document.addEventListener('DOMContentLoaded', initGatedResourceDownloads);
